import React, {Component} from 'react'
import {Link} from 'react-router'
import Moment from 'moment'

class Event extends Component {
  render() {
    return (
      <tr>
        <th scope="row">{this.props.item}</th>
        <td>
          <Link to={'/events/' + this.props.id}>
            <strong>{this.props.name}</strong>
          </Link>
        </td>
        <td>
          {Moment(this.props.startTime)
            .utc()
            .format('dddd, MMM Do YYYY - h:mm a')}
        </td>
      </tr>
    )
  }
}

export default Event



/** WEBPACK FOOTER **
 ** ./src/components/events/event.js
 **/